// extracted by mini-css-extract-plugin
export default {"select":"styles_select__lBnio","error":"styles_error__7pP-M"};